import React, { useState } from "react";

const UploadModal = ({ isOpen, onClose }) => {
  const [selectedFiles, setSelectedFiles] = useState([
    { name: "Internship_Certificate(Gourav).pdf", size: "17.2 KB" },
    { name: "Internship_Certificate(Gourav).pdf", size: "17.2 KB" },
  ]);

  const removeFile = (index) => {
    setSelectedFiles(selectedFiles.filter((_, i) => i !== index));
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    // Handle file drop logic here
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-blur flex items-center justify-center  bg-opacity-50 backdrop-blur-md  z-50">
      <div className="bg-white rounded-lg w-full max-w-2xl mx-4 max-h-[90vh] overflow-y-auto mt-8">
        {/* Header */}
        <div className="bg-[#572575] text-white p-3 rounded-t-lg flex justify-between items-center">
          <h2 className="text-2xl font-serif">Upload Required Document</h2>
          <button
            onClick={onClose}
            className="text-white hover:text-gray-200 text-2xl font-light"
          >
            ×
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          {/* Drag & Drop Area */}
          <div
            className="border-2 border-dashed border-[#572575] rounded-lg p-6 text-center mb-6"
            onDragOver={handleDragOver}
            onDrop={handleDrop}
          >
            <div className="flex justify-center mb-4">
              <div className="w-16 h-16 bg-[#572575] rounded-full flex items-center justify-center">
                <svg
                  className="w-4 h-4 text-white"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM6.293 6.707a1 1 0 010-1.414l3-3a1 1 0 011.414 0l3 3a1 1 0 01-1.414 1.414L11 5.414V13a1 1 0 11-2 0V5.414L7.707 6.707a1 1 0 01-1.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
            </div>
            <h3 className="text-xl font-semibold text-[#572575] mb-2">
              Drag & Drop File Here
            </h3>
            <p className="text-gray-500 mb-4">
              Supported formats: PDF, DOC, DOCX (Max size: 5MB)
            </p>
            <p className="text-black font-semibold">
              Upload your SOP and LOR documents
            </p>
          </div>

          {/* Selected Files */}
          <div className="mb-6">
            <h3 className="text-xl font-semibold text-[#572575] mb-4">
              Selected Files
            </h3>
            <div className="space-y-1">
              {selectedFiles.map((file, index) => (
                <div
                  key={index}
                  className="flex items-center justify-between bg-gray-50 p-1 rounded-lg"
                >
                  <div className="flex items-center">
                    <div className="w-8 h-4 bg-[#572575] rounded flex items-center justify-center mr-3">
                      <span className="text-white text-xs font-bold">PDF</span>
                    </div>
                    <span className="text-gray-800">
                      {file.name}({file.size})
                    </span>
                  </div>
                  <button
                    onClick={() => removeFile(index)}
                    className="w-8 h-8 bg-red-500 text-white rounded-full flex items-center justify-center hover:bg-red-600"
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex justify-end space-x-4">
            <button
              onClick={onClose}
              className="px-8 py-3 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 font-medium"
            >
              Cancel
            </button>
            <button className="px-8 py-3 bg-[#572575] text-white rounded-lg hover:bg-[#572575] font-medium">
              Upload
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadModal;
